import { render, staticRenderFns } from "./PolygonViewer.vue?vue&type=template&id=04eae612&scoped=true&"
import script from "./PolygonViewer.vue?vue&type=script&lang=ts&"
export * from "./PolygonViewer.vue?vue&type=script&lang=ts&"
import style0 from "./polygon-drawer.scss?vue&type=style&index=0&id=04eae612&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04eae612",
  null
  
)

export default component.exports